export default __webpack_public_path__ + "static/media/watch_espn.4e019015.png";